import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { WithObjectComponentHOC } from "../../HOC/WithObjectComponentHOC";
import { WithAppendHeaderAndFooterHOC } from "../../HOC/WithAppendHeaderAndFooterHOC";
import { WithAppendSidebarHOC } from "../../HOC/WithAppendSidebarHOC";
import ObjectRoomEdit from "./ObjectRoomEdit";
import { addRoom, clearRoom, getFields, getRoomById, getTypeList, updateRoom } from "./actions";
import { getRoomsList } from "../../globalState/object/actions";
import { WithSavingSnackBar } from "../../HOC/WithSavingSnackBar";
import { getRoomMain, getRoomPhotoApprovedToDB } from "./selector";


const mapStateToProps = (state) => {

  return {
    headerSubtitle: true,
    roomMain: getRoomMain(state),
    inRoomServices: state.objectRoomEdit.inRoom,
    typesList: state.objectRoomEdit.typesList,
    country: state.object.country,
    roomPhotoApprovedToDB: getRoomPhotoApprovedToDB(state),
    roomPhotoNotApprovedToDB: state.objectRoomEdit?.photos?.rejectedPhotos,

  }
};

export default compose(connect(mapStateToProps, {
  getRoomById,
  getTypeList,
  getFields,
  clearRoom,
  updateRoom,
  addRoom,
  getRoomsList,
}), withRouter, WithObjectComponentHOC, WithAppendHeaderAndFooterHOC, WithAppendSidebarHOC, WithSavingSnackBar)(ObjectRoomEdit);
